var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMultiply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-multiply_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-multiply_svg__b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-multiply_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F3F3F3",
    filter: "url(#icon-multiply_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.282.075l14.143 14.143-.707.707L.575.782z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.575 14.218L14.718.075l.707.707L1.282 14.925z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE1Ij4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9IjRqZGQyYnM5MmEiPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDAuMTQ4MjY4IDAgMCAwIDAgMC4xNDgyNjggMCAwIDAgMCAwLjE0ODI2OCAwIDAgMCAxLjAwMDAwMCAwIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgPGZpbHRlciBpZD0iamx4ZW5zZDYwYiI+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VHcmFwaGljIiB2YWx1ZXM9IjAgMCAwIDAgMC4xNDgyNjggMCAwIDAgMCAwLjE0ODI2OCAwIDAgMCAwIDAuMTQ4MjY4IDAgMCAwIDEuMDAwMDAwIDAiLz4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIGZpbHRlcj0idXJsKCM0amRkMmJzOTJhKSI+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8ZyBmaWxsPSIjRjNGM0YzIiBmaWx0ZXI9InVybCgjamx4ZW5zZDYwYikiPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNLTIgN0gxOFY4SC0yeiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgOCA3LjUpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMiA3SDE4VjhILTJ6IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOCA3LjUpIi8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconMultiply as ReactComponent };